import React, { useState, useEffect } from "react";
import formatPhoneNumber from "Helpers/PhoneNumber";
import ClassNames from "Helpers/Common";
import "Colors.css";
import "./InputField.css";

export const InputField = ({
  id,
  label,
  type = "text",
  placeholder = "",
  isRequired,
  maxLength,
  onBlur,
  isDisabled = false,
  value,
  onChange,
  children,
  onKeyDown,
  onIconClick,
}) => {
  const [fieldValue, setFieldValue] = useState("");
  const [fieldError, setFieldError] = useState("");

  useEffect(() => {
    if (value) {
      setFieldValue(value);
    }
  }, [value]);

  return (
    <div className="InputField_MainWrapper">
      {label && (
        <label htmlFor={id} className="sapphire block text-sm font-semibold">
          {label}
        </label>
      )}
      <div
        className={ClassNames(
          "InputField_FieldWrapper border rounded-md",
          fieldError
            ? "border-red-500 focus:ring-red-500 focus:border-red-500"
            : "border-gray-300 focus:ring-indigo-500 focus:border-indigo-500",
          isDisabled && "bg-gray-100"
        )}
      >
        <span onClick={onIconClick?.()}>{children}</span>
        <input
          id={id}
          name={id}
          type={type}
          value={fieldValue}
          placeholder={placeholder}
          maxLength={maxLength}
          required={!!isRequired}
          disabled={isDisabled}
          className={ClassNames(
            "appearance-none block w-full placeholder-gray-400 focus:outline-none sm:text-sm",

            isDisabled && "cursor-not-allowed"
          )}
          onChange={({ target }) => {
            setFieldError(false);
            setFieldValue(
              type === "tel" ? formatPhoneNumber(target.value) : target.value
            );
            onChange?.(
              type === "tel" ? formatPhoneNumber(target.value) : target.value,
              setFieldError
            );
          }}
          onBlur={() => {
            if (fieldValue) {
              onBlur?.(fieldValue, setFieldError);
            } else if (!!isRequired && !fieldValue) {
              onBlur?.("", setFieldError);
              setFieldError(`${label || placeholder} is required`);
            }
          }}
          onKeyPress={(e) => onKeyDown?.(e)}
        />
      </div>
      {fieldError && (
        <div className="InputField_ErrorWrapper text-sm text-red-600">
          {fieldError}
        </div>
      )}
    </div>
  );
};
